import { useParams } from "react-router";
import { useRootStore } from "store";
import { InboxType, inboxViews } from "models/inbox/inbox";
import { useGlobalContext } from "app/store/GlobalContext";

import "./InboxTabsPanel.scss";

export default function InboxTabsPanel() {
  const { inboxType } = useParams<{ inboxType: InboxType }>();
  const { handleNavigation } = useGlobalContext();

  const userInfo = useRootStore((s) => s.user.userInfo);
  const isInternal = userInfo?.type === "Internal";

  const tabs = isInternal
    ? inboxViews
    : inboxViews.filter((t) => t.value !== "all");

  return (
    <div className="inbox-tabs-wrapper">
      {tabs.map((tab) => {
        return (
          <button
            className={`tab ${inboxType === tab.value ? "tab-active" : ""}`}
            key={tab.value}
            onClick={(e) =>
              handleNavigation({
                url: `/inbox/${tab.value}`,
                eventTitle: "Inbox type",
                e: e
              })
            }
            aria-current={inboxType === tab.value ? "page" : undefined}
          >
            {tab.label}
          </button>
        );
      })}
    </div>
  );
}
